import { connect } from 'react-redux'
import { IStore } from '../../../../../../reducers'
import { withoutRemovedRooms } from '../../../../../../reducers/bookingCalendar/selectors/rooms'
import { IIntegrationsProps } from './Integrations'

const mapStateToProps = () => {
  const removedRooms = withoutRemovedRooms

  return (state: IStore): IIntegrationsProps => {
    const rooms = removedRooms(state)
    const bookingRoomsCount = rooms
      ? rooms.filter(room => room.booking).length
      : 0
    const iCalendarRoomsCount = rooms
      ? rooms.filter(room => room.iCalendar).length
      : 0

    return {
      bookingCount: bookingRoomsCount,
      iCalendarCount: iCalendarRoomsCount,
    }
  }
}

export default connect(mapStateToProps())
